function Stocks() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.init = function () {
    this._stocks();
  };

  this.initAllReady = function () {};

  this._stocks = function () {
    // same as the QModStockWidget.Dual.js file from the vendor but with "let"s changed to "var"s
    // and added "display: block" at the end to the component
    getWidgetIndex = function (dataObj) {
      const symbol =
        typeof dataObj.key !== "undefined"
          ? dataObj.key.symbol
          : dataObj.symbolinfo.key.symbol;
      const index = symbol.indexOf(":CA") === -1 ? 0 : 1;
      return index;
    };

    var widgetsComplete = [];

    formatCurrency = function () {
      $(".qm-number-positive,.qm-number-negative").each(function () {
        const text = $(this).html().toString().replace(/,/g, "");
        const val =
          text.indexOf(".") !== -1 ? parseFloat(text) : parseInt(text);
        const newVal =
          val < 1000
            ? number_format(val, 2, ".", ",")
            : number_format(val, 0, ".", ",");

        if (text.indexOf("$") === -1) $(this).html(newVal);
      });

      $(
        ".stock-widget__value.js--lastprice span, .stock-widget__value.js--pricedata span"
      ).each(function () {
        if ($(this).parent().find("span.dollar").length === 0) {
          const classes = $(this).attr("class");
          $(this)
            .parent()
            .prepend('<span class="dollar ' + classes + '">$</span>');
        }
      });
    };

    number_format = function (number, decimals, dec_point, thousands_sep) {
      number = number.toFixed(decimals);
      var nstr = number.toString();
      nstr += "";
      x = nstr.split(".");
      x1 = x[0];
      x2 = x.length > 1 ? dec_point + x[1] : "";
      var rgx = /(\d+)(\d{3})/;

      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");
      }

      return x1 + x2;
    };

    testComplete = function () {
      if (
        widgetsComplete.length > 0 &&
        $(".stock-widget").length === widgetsComplete.length
      ) {
        window.setTimeout(function () {
          formatCurrency();
        }, 800);
      } else {
        window.setTimeout(function () {
          testComplete();
        }, 300);
      }
    };

    populateStockWidgetFunds = function (q) {
      for (var i = 0; i < q.length; i++) {
        const widgetIndex = getWidgetIndex(q[i]);
        var widgetCount = 0;
        const marketCap = ".stock-widget .stock-widget__cap .js--marketcap";
        const selectors = [
          {
            sel: marketCap,
            val: q[i].fundamental.marketcap,
          },
        ];

        for (var x = 0; x < selectors.length; x++) {
          const s = selectors[x];
          widgetCount = 0;

          $(s.sel).each(function () {
            if (widgetCount === widgetIndex) {
              $(this).html(s.val);
            }

            widgetCount++;
          });
        }
      }
    };

    populateStockWidget = function (q) {
      for (var i = 0; i < q.length; i++) {
        var widgetCount = 0;
        const widgetIndex = getWidgetIndex(q[i]);
        const lastPrice = ".stock-widget .stock-widget__price .js--lastprice";
        const priceData = ".stock-widget .stock-widget__change .js--pricedata";
        const volume = ".stock-widget .stock-widget__volume .js--volume";
        const value =
          ".stock-widget .stock-widget__currency .stock-widget__value";
        const selectors = [
          {
            sel: lastPrice,
            val: q[i].pricedata.last,
          },
          {
            sel: priceData,
            val:
              q[i].pricedata.change +
              " (" +
              q[i].pricedata.changepercent +
              "%)",
          },
          {
            sel: volume,
            val: q[i].pricedata.sharevolume,
          },
          {
            sel: value,
            val: "Currency in " + q[i].key.currency,
          },
        ];

        for (var x = 0; x < selectors.length; x++) {
          const s = selectors[x];
          widgetCount = 0;

          $(s.sel).each(function () {
            if (widgetCount === widgetIndex) {
              $(this).html(s.val);
            }

            widgetCount++;
          });
        }

        window.setTimeout(function () {
          widgetsComplete.push(widgetIndex);
          $(".homepage__stock-widget")
            .addClass("visible")
            .css({ visibility: "visible", display: "block" });
        }, 300);
      }

      testComplete();
    };
  };
}
